import {createContext} from "react"
export const NwDashboardContext = createContext({
    nwDashboardContext: null,
    setNwDashboardAction: () => {},
})